import { HttpErrorResponse } from '@angular/common/http';
import { FirebaseError } from '@angular/fire/app';

import { ErrorType } from './error-type.enum';

export interface ApiErrorDto {
  key: ErrorType;
  message: string;
}

export class ApiError extends Error {
  constructor(
    readonly httpError: HttpErrorResponse,
    readonly readableMessage: string,
  ) {
    super();
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}

//eslint-disable-next-line
export function isApiErrorDto(e: any): e is ApiErrorDto {
  const errorTypes = Object.values(ErrorType);
  return e && typeof e === 'object' && 'key' in e && 'message' in e && errorTypes.includes(e.key);
}

export function isFirebaseError(e: unknown, code?: FirebaseErrorCode): e is FirebaseError {
  const isError = e instanceof FirebaseError;
  return code ? isError && e.code === code : isError;
}

// Error codes from Firebase which we want to handle individually.
// @see https://firebase.google.com/docs/reference/js/v8/firebase.auth.Error#code
export type FirebaseErrorCode =
  | 'auth/email-already-in-use'
  | 'auth/requires-recent-login'
  | 'auth/user-disabled'
  | 'auth/user-not-found'
  | 'auth/user-token-expired'
  | 'auth/wrong-password';
